module.exports = __webpack_public_path__ + "img/newsImg3-5.e95d31ac.png";